import React, { Fragment, useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faBan } from "@fortawesome/free-solid-svg-icons";

const ListNotificationsTypeActions = ({ data, dataUser, dataNotifications, getConfigurationNotificationUser }) => {

    const assignNotificationUser = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'notificacion-configuracion/create',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    id_notificaciones_tipo: data.data.original.id_notificaciones_tipo,
                    id_usuario: dataUser.id
                })
            }).then(response => {
                if(response.status != 500 && response.status != 403)
                {
                    return response.json();
                }
                else
                {
                    throw new Error('Data');
                }
            }).then(data => {
                getConfigurationNotificationUser();
            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    const unassignedNotificationsUser = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'notificacion-configuracion/eliminar',
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_notificaciones_tipo: data.data.original.id_notificaciones_tipo,
                id_usuario: dataUser.id
            })
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                getConfigurationNotificationUser();
            }
            else
            {
                throw new Error('Data');
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    useEffect(() => {
    }, [])

    return (
        <Fragment>
            <td role="cell">
                {
                    dataNotifications.some(datNot => datNot.notificacion_tipo == data.data.original.id_notificaciones_tipo) == false ? <Tooltip title="Configurar">
                        <IconButton aria-label="update-user" style={{ padding: 2 }}
                            onClick={() => {
                                assignNotificationUser();
                            }}
                        >
                            <FontAwesomeIcon icon={faCheck} />
                        </IconButton>
                    </Tooltip> : <Tooltip title="Retirar Configuración">
                        <IconButton aria-label="update-user" style={{ padding: 2 }}
                            onClick={() => {
                                unassignedNotificationsUser();
                            }}
                        >
                            <FontAwesomeIcon icon={faBan} />
                        </IconButton>
                    </Tooltip>
                }
            </td>
        </Fragment>)
}

export default ListNotificationsTypeActions;